import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CREATED, UPDATED, VIEWED } from '@careapp-group/core';
import { ModelEventDto } from '@careapp-group/ng-sdk';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MemberDto } from '@careapp-group/ng-sdk';
import * as actions from '../../store';
import { getFileHistory, getFileHistoryLoading } from '../../store/files/files-selectors';
import { getMembersState } from '../../store';
@Component({
  selector: 'ca-file-history',
  templateUrl: './file-history-dialog.component.html',
  styleUrls: ['./file-history-dialog.component.scss'],
  standalone: false,
})
export class FileHistoryDialogComponent implements OnInit {
  history$: Observable<ModelEventDto[]>;
  loadingHistory$: Observable<boolean>;
  members$: Observable<{ [id: string]: MemberDto }>;

  CREATED = CREATED;
  UPDATED = UPDATED;
  VIEWED = VIEWED;

  constructor(
    private store: Store<any>,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: { fileId: string },
  ) {}
  ngOnInit() {
    this.store.dispatch(actions.requestFileHistory({ fileId: this.data.fileId }));
    this.loadingHistory$ = this.store.select(getFileHistoryLoading);
    this.history$ = this.store.select(getFileHistory).pipe(
      filter((entities) => !!entities),
      map((entities) => entities[this.data.fileId] ?? []),
    );
    this.members$ = this.store.select(getMembersState).pipe(map((state) => state.entities));
  }
}
